import { useQuery, gql } from '@apollo/client';

const REVIEWER_STATS_TIME_SERIES_FRAGMENT = gql`
  fragment ReviewerStatsTimeSeries on ReviewerStatsCollection {
    reviewerStats {
      reviewer {
        id
        name
        avatarUrl
      }
      stats {
        date
        value
      }
    }
    aggregatedStats {
      date
      value
    }
  }
`;

export const GET_REVIEWER_STATS_TIME_SERIES = gql`
  ${REVIEWER_STATS_TIME_SERIES_FRAGMENT}
  query GetReviewerStatsTimeSeries(
    $granularity: GranularityEnum!,
    $repositoryIds: [ID!],
    $startDate: ISO8601DateTime,
    $endDate: ISO8601DateTime,
    $groupBy: ReviewerStatsGroupByEnum
  ) {
    reviewerStatsTimeSeries(
      filterBy: {
        repositoryId: { in: $repositoryIds },
        submittedAt: { gte: $startDate, lte: $endDate }
      },
      granularity: $granularity,
      groupBy: $groupBy
    ) {
      totalReviews {
        ...ReviewerStatsTimeSeries
      }
      medianTimeToReview {
        ...ReviewerStatsTimeSeries
      }
      totalComments {
        ...ReviewerStatsTimeSeries
      }
    }
  }
`;

export const useReviewerStatsTimeSeriesQuery = ({
  granularity,
  repositoryIds,
  startDate,
  endDate,
  groupBy,
}) => {
  const { data, loading, refetch } = useQuery(
    GET_REVIEWER_STATS_TIME_SERIES,
    {
      variables: {
        granularity,
        repositoryIds,
        startDate,
        endDate,
        groupBy,
      },
    },
  );

  return { reviewerStatsTimeSeries: data?.reviewerStatsTimeSeries, loading, refetch };
};
